module.exports = __webpack_public_path__ + "media/images/icon-button-favorite-active-2aa8bcab08253b975fb9e3f17fadd271.svg";